import {keys} from '../../../constants/KeyCodes';

const shortcuts = [
    keys.PAGE_UP,
    keys.PAGE_DOWN,
    keys.HOME,
    keys.END,
    keys.ARROW_DOWN,
    keys.ARROW_UP
];

export const preventDefaultPageShortcuts = e => {
    const key = e.key;
    if (shortcuts.includes(key)) {
        e.preventDefault();
    }
};
